// extracted by mini-css-extract-plugin
export default {"loginModalContainer":"LoginModal_loginModalContainer__Xe43T","title":"LoginModal_title__hohNg","subtitle":"LoginModal_subtitle__Tkq1W","button":"LoginModal_button__yX2eg"};